// document.addEventListener("DOMContentLoaded", e => {
    
//     window.addEventListener('scroll', e => {
//         changeConnectionIcon()
//     })

    // changeConnectionIcon()

    // function changeConnectionIcon() {

    //     const elem = document.querySelector("#connectionIcon")
    //     if (window.pageYOffset >= 500) {
    //         elem.classList.add("active")
    //     } else {
    //         elem.classList.remove("active")
    //     }
    // }
// })
